import {
  ConsentDefinitionType,
  ConsentSettingType,
  IMeterpointConsent,
} from "./meterpointConsent.types"
import { Dayjs } from "dayjs"

export enum SmartReadFrequencies {
  HALF_HOURLY = "HALF_HOURLY",
  DAILY = "DAILY",
  MONTHLY = "MONTHLY",
}

export class MeterpointConsent implements IMeterpointConsent {
  constructor(
    public consentDefinition: ConsentDefinitionType,
    public setting: ConsentSettingType,
    public meterPointIdentifier: string,
    public startDate: Dayjs,
    public endDate?: Dayjs,
  ) {}
}
